import AnimatedHero from '@/components/AnimatedHero'
import ContactForm from '@/components/ContactForm'
import FlexibleContent from '@/components/FlexibleContent'
import Main from '@/components/Main'
import Posts from '@/components/Posts'
import SEO from '@/components/SEO'
import styles from '@/styles/pages/_Home.module.scss'
export default function Component(props) {
  if (props?.loading) {
    return null
  }

  const flexibleContent = props?.data?.pages?.nodes?.[0]?.template?.flexibleContent?.flexibleContentFields ?? []
  const form = props?.data?.contactForm
  const { title, metaDesc } = props?.data?.pages?.nodes?.[0]?.seo || {}

  return (
    <>
      <SEO title={title} description={metaDesc} />

      <AnimatedHero />

      <Main className={styles.home} id="main-home">
        <FlexibleContent content={flexibleContent} />

        <div data-aos="fade-up">
          <Posts posts={props?.data?.posts?.nodes} id="posts-list" />
        </div>

        {form && <ContactForm form={form} />}
      </Main>
    </>
  )
}
